module.exports = __webpack_public_path__ + "files/f2d52b1e74574ab35ea7d4d4eeb7c9e7.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/ubuntu-bolditalic-webfont.ttf
 ** module id = 1027
 ** module chunks = 0
 **/